import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom'; // se usar react-router-dom v6
import axios from 'axios';
import {
  Container,
  Title,
  Text,
  Form,
  RadioLabel,
  RadioInput,
  Button,
  ErrorText,
} from "./styles"; // <-- importando os estilos
import Globais from '../../components/Globais';

export default function ViewPreferenciaMensagem() {
  const [loading, setLoading] = useState(false);
  const [resposta, setResposta] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [error, setError] = useState("");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // pega token da query

  useEffect(() => {
    if (!token) {
      setError("Token inválido ou não fornecido.");
    }
  }, [token]);

  const options = [
  { 
    label: "Avisar em 1 mês", 
    value: "LEMBRAR_1M",
    description: "Você continuará recebendo outras comunicações normalmente."
  },
  { 
    label: "Avisar em 3 meses", 
    value: "LEMBRAR_3M",
    description: "Você continuará recebendo outras comunicações normalmente."
  },
  { 
    label: "Avisar em 6 meses", 
    value: "LEMBRAR_6M",
    description: "Você continuará recebendo outras comunicações normalmente."
  },
  { 
    label: "Não quero mais receber este tipo de mensagem", 
    value: "NAO_INTERESSADO",
    description: "Não enviaremos mais mensagens relacionadas a esta campanha."
  },
];


  const handleSubmit = async (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    if (!resposta) return setError("Escolha uma opção");

    setLoading(true);
    setError("");

    try {
      const URL = `${Globais.DOMINIOBACK}/mensagens/preferencia/${token}`;
      const res = await axios.patch(URL, {
        token,
        respostaUsuario: resposta,
      });

      setMensagem(res.data.message || "Sua preferência foi atualizada!");
    } catch (err) {
      // Pega mensagem do backend (Nest)
      const backendMsg = err.response?.data?.message;
      if (Array.isArray(backendMsg)) {
        setError(backendMsg.join(", "));
      } else if (backendMsg) {
        setError(backendMsg);
      } else {
        setError("Ocorreu um erro, tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (mensagem || error) {
  return (
    <Container>
      <Title>{mensagem ? "Obrigado!" : "Ops!"}</Title>
      <Text>{mensagem || error}</Text>

      <a href="/" style={{ marginTop: "20px", color: "#0077cc", textDecoration: "underline" }}>
        Voltar para a página principal
      </a>
    </Container>
  );
}


  return (
    <Container>
      <Title>Atualize sua preferência</Title>
      <Text>Escolha uma opção para esta mensagem:</Text>
      <Form onSubmit={handleSubmit}>
        {options.map((opt) => (
  <RadioLabel key={opt.value}>
    <RadioInput
      type="radio"
      name="resposta"
      value={opt.value}
      onChange={(e) => setResposta(e.target.value)}
      disabled={loading}
    />
    <div>
      <strong>{opt.label}</strong>
      {opt.description && (
        <small style={{ color: "#666", display: "block", marginTop: 4 }}>
          {opt.description}
        </small>
      )}
    </div>
  </RadioLabel>
))}

        {error && <ErrorText>{error}</ErrorText>}
        <Button type="submit" disabled={loading}>
          {loading ? "Atualizando..." : "Enviar"}
        </Button>
      </Form>
    </Container>
  );
}
